import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Card from './card';
import Deductions from 'bundles/apex/deals/show/overview/cards/transaction_side/deductions';
import InternalBrokers from 'bundles/apex/deals/form/fields/internal_brokers';
import OutsideBrokers from 'bundles/apex/deals/form/fields/outside_brokers';
import TransactionSideTotals from 'bundles/apex/deals/form/fields/transaction_side_totals';
import { getTransactionSideLabel } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

export function TransactionSideCard({ deal, transactionSide, transactionSideOptions }) {
  const label = getTransactionSideLabel(transactionSide, transactionSideOptions);

  return <>
    <Card label={label}>
      <TransactionSideTotals deal={deal} transactionSide={transactionSide} />

      <h6>Outside Brokers</h6>
      <OutsideBrokers transactionSide={transactionSide} />

      <div className="mt-3">
        <Deductions transactionSide={transactionSide} />
      </div>

      <h6>Internal Brokers</h6>
      <InternalBrokers transactionSide={transactionSide} />
    </Card>
  </>;
}

TransactionSideCard.propTypes = {
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number.isRequired,
      grossPercent: PropTypes.number.isRequired,
      transactionSide: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
  transactionSideOptions: PropTypes.array,
};

const mapStateToProps = state => ({
  deal: state.deal,
  transactionSideOptions: state.options.transactionSide,
});

export default connect(mapStateToProps)(TransactionSideCard);
